var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 13","width":"17px","height":"13px"}},[_c('path',{attrs:{"fill":"#6D9E11","fill-rule":"nonzero","d":"M5.281818 9.9977275L1.320455 6.0363638 0 7.3568184l5.281818 5.2818183L16.6 1.3204546 15.279546 0z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }